// Types accepted: yellow, black, outlined
<template>
  <button
    class="rounded-md py-1 sm:py-1 md:py-3"
    :class="styles"
    @click="clicked"
  >
    <div
      :class="[iconLeft ? 'flex flex-row-reverse' : 'flex']"
      class="w-full items-center justify-center"
    >
      <slot />
      <div
        v-if="!!iconPath"
        class="h-6 w-6"
        :class="[iconLeft ? 'mr-2' : 'ml-2']"
      >
        <!-- TODO: Code rafactor is needed in order to use only one tailwind tag for icon size -->
        <img
          class="h-full w-full"
          :src="iconPath"
          alt="icon"
        />
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    iconPath: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'yellow',
    },
    className: {
      type: String,
      default: '',
    },
    iconLeft: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  data() {
    return {
      searchable: false,
    };
  },
  computed: {
    styles: function () {
      if (this.disabled) {
        return `${this.disabledStyles} ${this.className}`;
      }
      return `${this.style} ${this.sizes} ${this.search} ${this.className}`;
    },
    style: function () {
      switch (this.variant) {
        case 'yellow':
          return 'text-white bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700';
        case 'yellow-black':
          return 'text-black bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700';
        case 'yellow-disabled':
          return 'text-white bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700';
        case 'black':
          return 'text-white bg-body-color hover:bg-dark-gray active:bg-dark-blue';
        case 'outlined':
          return 'text-gray-over-dark border border-gray-over-dark hover:text-body-color hover:border-body-color active:text-dark-gray active:border-dark-gray';
        case 'transparent':
          return 'text-body-color hover:bg-off-white active:bg-light-gray';
        case 'light-white':
          return 'text-white bg-white bg-opacity-10 hover:bg-opacity-20 active:bg-opacity-30';
        case 'light-yellow':
          return 'text-yellow-500 bg-yellow-500 bg-opacity-20 hover:bg-opacity-30 active:bg-opacity-50';
        case 'gray':
          return 'text-dark-gray bg-gray-100 hover:bg-hovered-gray active:text-dark-gray active:border-dark-gray';
        case 'blue':
          return 'text-white bg-neutral-subtle-bold hover:bg-neutral-blue';

        default:
          return '';
      }
    },
    disabledStyles: function () {
      switch (this.variant) {
        case 'yellow':
          return 'text-white bg-light-gray ';
        case 'yellow-black':
          return 'text-neutral-subtlest bg-light-gray ';
        case 'yellow-disabled':
          return 'text-white bg-yellow-500';
        case 'black':
          return 'text-white bg-light-gray ';
        case 'outlined':
          return 'text-light-gray border border-light-gray ';
        case 'transparent':
          return 'text-body-color ';
        case 'light-white':
          return 'text-white bg-white bg-opacity-10 ';
        case 'light-yellow':
          return 'text-yellow-500 bg-yellow-500 bg-opacity-20 ';
        default:
          return '';
      }
    },
    sizes: function () {
      switch (this.size) {
        case 'md':
          return 'w-20 h-6';
        case 'lg':
          return 'w-36 h-14';
        case 'xl':
          return 'w-52 h-14';
        default:
          return '';
      }
    },
    search: function () {
      if (this.searchable) {
        return 'flex flex-row align-center justify-between';
      }
      return '';
    },
  },
  methods: {
    clicked: function () {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>
